import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation

const Profile = () => {
    const navigate = useNavigate(); // Initialize useNavigate hook
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (password !== confirmPassword) {
            setError("Passwords do not match!");
            return;
        }

        // Simulate a successful password change operation
        setSuccess("Password changed successfully!");
        setPassword('');
        setConfirmPassword('');
    };

    return (
        <Container fluid className="d-flex align-items-center justify-content-center" style={{ height: "100vh", backgroundColor: "#f9f9f9" }}>
            <Row className="w-75">
                {/* Profile Section */}
                <Col md={6} className="text-center">
                    <div className="profile-img mb-3">
                        <img
                            src="https://via.placeholder.com/100"
                            alt="Profile"
                            className="rounded-circle"
                        />
                    </div>
                    <h5>Admin Name</h5>
                    <p>Email: admin@example.com</p> {/* Example user email */}
                </Col>

                {/* Manage Account Section */}
                <Col md={6}>
                    <Card className="p-4 shadow-sm" style={{ borderRadius: "15px" }}>
                        <h5 className="text-center mb-4">Manage Account</h5>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {success && <Alert variant="success">{success}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formChangePassword">
                                <Form.Control 
                                    type="password" 
                                    placeholder="Change Password" 
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)} 
                                />
                            </Form.Group>
                            <Form.Group className="mb-4" controlId="formConfirmPassword">
                                <Form.Control 
                                    type="password" 
                                    placeholder="Confirm Password" 
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)} 
                                />
                            </Form.Group>
                            <Button type="submit" className="w-100 Submit-Btn border-0 mb-2" style={{ borderRadius: "20px" }}>
                                Submit
                            </Button>
                        </Form>
                        <Button variant="light" className="w-100" onClick={() => navigate(-1)} style={{ borderRadius: "20px" }}>
                            Back
                        </Button>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Profile;